import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAction = (actionFn, meta) => {
  const dispatch = useDispatch();
  const action = useCallback(
    (...args) => {
      if (actionFn) {
        return dispatch(actionFn(...args));
      }
      return null;
    },
    [dispatch]
  );

  if (meta) {
    Object.keys(meta).forEach((key) => {
      action[key] = meta[key];
    });
  }

  return action;
};
